import DefaultTermsAndConditions from './DefaultTermsAndConditions';
import StarTermsAndConditions from './StarTermsAndConditions';
import generateRender from 'shared/utils/generateRender';

const TermsAndConditions = generateRender({
  default: DefaultTermsAndConditions,
  star: StarTermsAndConditions
})

export default TermsAndConditions;